import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Box
} from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import "../../../styles/Auth/return.css";
import { getData } from "../../../webService/webservice.js";
const ReturnList = () => {
    const navigate = useNavigate();
    const handleAddReturn = () => {
        navigate('/sales-return/add');
    }
    const [searchQuery, setSearchQuery] = useState('');
    const [returns, setReturns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [showPopup, setShowPopup] = useState(false);
    const [returnData, setReturnData] = useState(null);
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Date',
        'Invoice No',
        'Customer Name',
        'Return Product',
        'Return Quantity',
        'Total Price',
        'Return Payment Method',
        'Action'
    ];
    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };


    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const fetchReturns = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            title: searchQuery?.trim() || ""
        };
        try {
            console.log("Fetching Returns with params:", params);
            const response = await getData("/salesreturns/salesreturns", params);
            console.log("Raw API Response:", response);
            const result = response?.data?.[0];
            const returnList = result?.paginatedResults || [];
            const totalCount = result?.totalCount || 0;
            const totalPages = result?.totalPages || 0;

            console.log("Return List:", returnList);
            setReturns(returnList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Returns");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchReturns(currentPage, limit, searchQuery);
    }, [currentPage, limit, refreshKey, searchQuery]);

    const handleViewReturn = async (returnId) => {
        try {
            setLoading(true);

            // Assuming sessionToken is from sessionStorage
            const sessionToken = sessionStorage.getItem("sessionToken");

            // Fetch data using your getData function
            const response = await getData(`salesreturns/salesreturn/${returnId}`, sessionToken);

            // Check if response is already JSON
            const data = response?.data || response;

            // Set the view data
            setReturnData(data);
            setShowPopup(true);
        } catch (error) {
            console.error("Error fetching Return:", error);
            toast.error(error.message || "Failed to fetch Return data");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="return-layout">
            <div className="return-content">
                <div className="return-main">
                    <div className="return-widgets">
                        <div className="return-widgets-header">
                            <h3>Returns</h3>
                            <input
                                type="text"
                                placeholder="Search"
                                className="return-search-input"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                        <button className="add-btn-return" onClick={handleAddReturn}>+ Add Return</button>
                    </div>
                    <TableContainer component={Paper} sx={{
                        borderRadius: '12px',
                        maxHeight: 400,
                        overflowY: "auto",
                        '&::-webkit-scrollbar': { display: 'none' },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                    }}>
                        <Table className="custom-return-table"
                            sx={{
                                '& td, & th': {
                                    border: 'none',
                                },
                                border: 'none',
                            }}>
                            <TableHead className="custom-return-head">
                                <TableRow>
                                    {headings.map((heading, index) => (
                                        <TableCell
                                            key={index}
                                            sx={{
                                                border: 'none',
                                                padding: '12px 16px',
                                                textAlign: 'center',
                                                position: "sticky",
                                                top: 0,
                                                backgroundColor: '#E6cf80',
                                                zIndex: 1,
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '4px',
                                                    color: '#000000',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {heading}
                                            </Typography>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {returns.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5}>
                                            <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                No returns found.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    returns.map((returnItem, index) => (
                                        <TableRow key={returnItem._id}>
                                            <TableCell>
                                                <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                            </TableCell>
                                            <TableCell><Typography sx={commonCellStyle}>{new Date(returnItem.createdAt).toLocaleString()}</Typography></TableCell>
                                            <TableCell><Typography sx={commonCellStyle}>{returnItem.invoiceDetails?.[0]?.invoiceNo || "-"}</Typography></TableCell>
                                            <TableCell><Typography sx={commonCellStyle}> {
                                                `${returnItem.customerDetails?.[0]?.name} `
                                            }</Typography></TableCell>
                                            <TableCell><Typography sx={commonCellStyle}>{returnItem?.productDetails?.[0].title}</Typography></TableCell>
                                            <TableCell><Typography sx={commonCellStyle}>{returnItem?.items?.[0].qtyReturned}</Typography></TableCell>
                                            <TableCell><Typography sx={commonCellStyle}>{returnItem?.items?.[0].rate}</Typography></TableCell>
                                            <TableCell>
                                                <Typography sx={commonCellStyle}>{returnItem?.items?.[0].rate * returnItem?.items?.[0].qtyReturned}</Typography>
                                            </TableCell>
                                            {/* <TableCell>
                                                <Typography sx={commonCellStyle}>{returnItem.totalAmount}</Typography>
                                            </TableCell> */}
                                            <TableCell>
                                                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                    <Icon icon={plusIcon} width={20} height={20} onClick={() => handleViewReturn(returnItem._id)} />
                                                </Box>
                                            </TableCell>
                                        </TableRow>

                                    ))
                                )}

                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className="return-bottom">
                        <div className="return-section show-entries">
                            <span className="text-label">Show</span>
                            <select className="entries-select" value={limit}
                                onChange={handleItemsPerPageChange}
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="all">All</option>
                            </select>
                            <span className="text-label">Entries</span>
                        </div>
                        <div className="return-section showing-range">
                            {
                                limit === 'all'
                                    ? `Showing all ${totalCount} entries`
                                    : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                            }
                        </div>
                        <div className="return-section spacer"></div>
                        <div className="return-section pagination-buttons">
                            <button
                                className="pagination-btn"
                                disabled={currentPage === 1}
                                onClick={() => handlePageChange("prev")}
                            >Previous</button>
                            <button
                                className="pagination-btn"
                                disabled={currentPage === totalPages}
                                onClick={() => handlePageChange("next")}
                            >Next</button>
                        </div>
                    </div>
                </div>
                {showPopup && returnData && (
                    <div className="popup-overlay">
                        <div className="popup-content">
                            <div className="popup-header">
                                <h2>Sales Return Details</h2>
                                <button className="close-btn" onClick={() => setShowPopup(false)}>×</button>
                            </div>

                            <div className="popup-section">
                                <p><b>Return Date:</b> {new Date(returnData.createdAt).toLocaleString()}</p>
                                <p><b>Customer:</b> {returnData.customerName}</p>
                                <p><b>Phone:</b> {returnData.customerPhone}</p>
                                <p><b>Invoice No:</b> {returnData.invoiceId?.invoiceNo}</p>
                            </div>

                            <div className="divider"></div>

                            <h3 className="section-title">Returned Items</h3>

                            {returnData.items?.map((item, i) => (
                                <div key={i} className="item-box">
                                    <p><b>Product:</b> {item.productId?.title}</p>
                                    <p><b>Qty Returned:</b> {item.qtyReturned}</p>
                                    <p><b>Rate:</b> ₹{item.rate}</p>
                                    <p><b>Reason:</b> {item.reason}</p>
                                </div>
                            ))}

                            <div className="divider"></div>

                            <div className="popup-section">
                                <p><b>Total Refund:</b> ₹{returnData.totalRefundAmount}</p>
                                <p><b>Remarks:</b> {returnData.remarks}</p>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default ReturnList;